<div class="box-body">
  @for (ctrl of _controls; track ctrl) {
    <div class="control type-{{ ignoreCatchObservable(ctrl?.TypeName) | async }}">
      @if (
        (ignoreCatchObservable(ctrl?.ReadPermission) | async) &&
        (ignoreCatchObservable(ctrl?.Visible) | async) &&
        !ctrl?.hasErrors
      ) {
        <div class="row">
          @if ((ignoreCatchObservable(ctrl?.ExpandArea) | async) != true) {
            <div
              class="col-left"
              matTooltipShowDelay="300"
              [matTooltip]="(ignoreCatchObservable(ctrl?.Description) | async)?.Values"
              [matTooltipDisabled]="ignoreCatchObservable(showDescription) | async"
              matTooltipClass="viewtab-control-tooltip"
            >
              {{ (ignoreCatchObservable(ctrl?.Caption) | async)?.Values }}
              @if (
                (ignoreCatchObservable(ctrl?.Enabled) | async) &&
                editEnabled &&
                (ignoreCatchObservable(ctrl?.getBooleanPropertyValues('Required')) | async) == true
              ) {
                <span class="required">*</span>
              }
              @if (
                (ignoreCatchObservable(showDescription) | async) &&
                (ignoreCatchObservable(ctrl?.Description) | async)?.Values
              ) {
                <p class="description">
                  {{ (ignoreCatchObservable(ctrl?.Description) | async)?.Values }}
                </p>
              }
            </div>
          }
          <div
            class="col-right"
            [class.col-expand]="(ignoreCatchObservable(ctrl?.ExpandArea) | async) == true"
          >
            @switch (ignoreCatchObservable(ctrl?.TypeName) | async) {
              @case ('UocTextBox') {
                <ctrl-textbox
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-textbox>
              }
              @case ('UocModuleSync') {
                <ctrl-modulesync [config]="ctrl" #control></ctrl-modulesync>
              }
              @case ('UocLabel') {
                <ctrl-label [config]="ctrl"></ctrl-label>
              }
              @case ('UocCaptionControl') {
                <ctrl-captioncontrol [config]="ctrl"></ctrl-captioncontrol>
              }
              @case ('UocColorPicker') {
                <ctrl-colorpicker></ctrl-colorpicker>
              }
              @case ('UocSlider') {
                <ctrl-slider
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-slider>
              }
              @case ('UocNumericBox') {
                <ctrl-numericbox
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-numericbox>
              }
              @case ('UocDateTimeControl') {
                <ctrl-datetime
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-datetime>
              }
              @case ('UocDropDownList') {
                <ctrl-dropdown
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [objectType]="objectType"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-dropdown>
              }
              @case ('UocMultiSelect') {
                <ctrl-multiselect
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [objectType]="objectType"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-multiselect>
              }
              @case ('UocListView') {
                <ctrl-listview
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  [objectType]="objectType"
                  [objectID]="objectID"
                  [objectDisplayName]="objectDisplayName"
                  #control
                ></ctrl-listview>
              }
              @case ('UocRadioButtonList') {
                <ctrl-radiobuttons
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [objectType]="objectType"
                  [changeDetection]="true"
                  [objectType]="objectType"
                  #control
                ></ctrl-radiobuttons>
              }
              @case ('UocSimpleRadioButton') {
                <ctrl-simpleradiobuttons
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  [objectType]="objectType"
                  #control
                ></ctrl-simpleradiobuttons>
              }
              @case ('UocCheckBox') {
                <ctrl-checkbox
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-checkbox>
              }
              @case ('UocIdentityPicker') {
                <div>
                  @if (
                    (ignoreCatchObservable(ctrl?.getPropertyValues('Mode')) | async) !==
                    'MultipleResult'
                  ) {
                    <ctrl-identitypicker-single
                      [config]="ctrl"
                      [editEnabled]="editEnabled"
                      [freshResource]="freshResource"
                      [changeDetection]="true"
                      [objectDisplayName]="objectDisplayName"
                      #control
                    ></ctrl-identitypicker-single>
                  } @else {
                    <ctrl-identitypicker-multi
                      [config]="ctrl"
                      [editEnabled]="editEnabled"
                      [freshResource]="freshResource"
                      [changeDetection]="true"
                      [objectType]="objectType"
                      [objectID]="objectID"
                      [objectDisplayName]="objectDisplayName"
                      #control
                    ></ctrl-identitypicker-multi>
                  }
                </div>
              }
              @case ('UocFileUpload') {
                <ctrl-fileupload
                  [objectType]="objectType"
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-fileupload>
              }
              @case ('UocFileDownload') {
                <ctrl-filedownload
                  [objectType]="objectType"
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-filedownload>
              }
              @case ('UocPictureBox') {
                <ctrl-picturebox
                  [config]="ctrl"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #roControl
                ></ctrl-picturebox>
              }
              @case ('UocHyperLink') {
                <ctrl-hyperlink
                  [config]="ctrl"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #roControl
                ></ctrl-hyperlink>
              }
              @case ('UocActionBar') {
                <ctrl-actionbar
                  [config]="ctrl"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #roControl
                ></ctrl-actionbar>
              }
              @case ('UocData') {
                <ctrl-data
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-data>
              }
              @case ('UocCommonMultiValueControl') {
                <ctrl-commonmultivalue
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-commonmultivalue>
              }
              @case ('UocMarkdownArea') {
                <ctrl-markdownarea
                  [config]="ctrl"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #roControl
                ></ctrl-markdownarea>
              }
              @case ('UocFilterBuilder') {
                <ctrl-filterbuilder
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-filterbuilder>
              }
              @case ('UocRequestSummary') {
                <ctrl-requestsummary
                  [config]="ctrl"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #roControl
                ></ctrl-requestsummary>
              }
              @case ('UocProcessDesigner') {
                <ctrl-processdesigner
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [resource]="resource"
                  [changeDetection]="true"
                  #control
                ></ctrl-processdesigner>
              }
              @case ('UocConnectedSystemScopeControl') {
                <ctrl-connected-system-scope
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-connected-system-scope>
              }
              @case ('UocSyncRuleParameterControl') {
                <ctrl-syncrule-parameter
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-syncrule-parameter>
              }
              @case ('UocRelationshipCriteriaControl') {
                <ctrl-relationship-criteria
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-relationship-criteria>
              }
              @case ('UocInboundAttributeFlowControl') {
                <ctrl-inbound-attribute-flow
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-inbound-attribute-flow>
              }
              @case ('UocOutboundAttributeFlowControl') {
                <ctrl-outbound-attribute-flow
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-outbound-attribute-flow>
              }
              @case ('UocInitialAttributeFlowControl') {
                <ctrl-initial-attribute-flow
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-initial-attribute-flow>
              }
              @case ('UocIcon') {
                <ctrl-icon
                  [config]="ctrl"
                  [editEnabled]="editEnabled"
                  [freshResource]="freshResource"
                  [changeDetection]="true"
                  #control
                ></ctrl-icon>
              }
              @default {
                <div>No Control for Type {{ ignoreCatchObservable(ctrl?.TypeName) | async }}.</div>
              }
            }
            @if (
              (ignoreCatchObservable(showHint) | async) &&
              (ignoreCatchObservable(ctrl?.Hint) | async)?.Values
            ) {
              <p class="hint">
                {{ (ignoreCatchObservable(ctrl?.Hint) | async)?.Values }}
              </p>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (_errors.length) {
    <div class="controlErrors alert alert-warning" role="alert">
      @if (!showErrorsDetail) {
        <button mat-icon-button (click)="showErrorsDetail = true">
          <mat-icon>add_box</mat-icon>
        </button>
      } @else {
        <button mat-icon-button (click)="showErrorsDetail = false">
          <mat-icon>indeterminate_check_box</mat-icon>
        </button>
      }
      @if (_errors.length !== 1) {
        <language
          key="ViewtabControlsErrors"
          defaultValue="There are {0} errors on this tab."
          [args]="[_errors.length]"
        ></language>
      } @else {
        <language
          key="ViewtabControlsErrorsSingle"
          defaultValue="There is a single control with an error on this tab."
        ></language>
      }
      @if (showErrorsDetail) {
        <div>
          <ul>
            @for (e of _errors; track e) {
              <li>{{ e }}</li>
            }
          </ul>
        </div>
      }
    </div>
  }
</div>
